import { render, staticRenderFns } from "./SmartTableRequests.vue?vue&type=template&id=8d85f20c"
import script from "./SmartTableRequests.js?vue&type=script&lang=js&external"
export * from "./SmartTableRequests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports